import React, { useState } from 'react';

import { Navigation, TabView } from '@swf/poker';

import { NAVIGATION_TABS } from '../../constants';
import type { NavigationTabTypes } from '../../types';
import { NavigationTabs } from '../../types';
import More from '../More/More';
import ThePasses from '../ThePasses/ThePasses';
import ThePath from '../ThePath/ThePath';

import styles from './PowerPath.scss';

const PowerPath: React.FC = () => {
  const [selectedTab, setSelectedTab] = useState<NavigationTabTypes>(NavigationTabs.thePath);
  const onTabSelected = (tabName: NavigationTabTypes) => {
    setSelectedTab(tabName);
  };

  return (
    <div className={styles.wrapper}>
      <div className={styles.container}>
        <div className={styles.content}>
          <Navigation
            navTabs={NAVIGATION_TABS}
            selectedTab={selectedTab}
            onSelectTab={onTabSelected}
          />
          <TabView activeTab={selectedTab}>
            <TabView.Tab name={NavigationTabs.thePath}>
              <ThePath />
            </TabView.Tab>
            <TabView.Tab name={NavigationTabs.thePasses}>
              <ThePasses />
            </TabView.Tab>
            <TabView.Tab name={NavigationTabs.more}>
              <More />
            </TabView.Tab>
          </TabView>
        </div>
      </div>
    </div>
  );
};

export default PowerPath;
